import { useRouter, WebRouter } from '@24i/nxg-core-router/src/NextRouter';
import { useAppStart } from '@24i/nxg-sdk-smartott/src/context/AppStartContext';
import { useQueryClient } from 'react-query';

export * from './shared';

export const useStartPageNavigation = () => {
    const router = useRouter() as WebRouter;
    const { runStartSequence } = useAppStart();
    const queryClient = useQueryClient();

    const navigateToStartPage = () => runStartSequence(undefined, router);

    const login = async () => {
        queryClient.clear();
        await navigateToStartPage();
    };

    return { navigateToStartPage, login };
};
